import React, { useEffect, useState } from 'react';
import Menu from '../../components/Menu';
import api from '../../services/api';


function Cadastro(props){    
    const [dados, setDados] = useState({});
    const [senha, setSenha] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmar, setConfirmar] = useState('');
    const [msg, setMsg] = useState('');
    const [trava, setTrava] = useState(true);
    useEffect( () => {
        async function getDados(){
            try{
                var dados = await api.get('/perfil');
                setTrava(false);
                setDados(dados.data);
            }catch(e){
                setTrava(true);
                var dados = '';                
            }

        }
       getDados();
    },[api, setDados]);

    if(!window.localStorage.getItem('token')){
        window.location = './Sair';
        return;
    }

    const Editar = async (e) => {
        e.preventDefault(0);
        if(novaSenha.length < 3){
            setMsg('Nova senha muito curta');
        }else{
            try{
                var result = await api.post('/AltSenha', {usuario: dados.usuario, senha: senha, novasenha: novaSenha, confirmar: confirmar});
                if(result.data.msg){
                    setMsg(result.data.msg);
                }
            }catch(e){
                setMsg('Ocorreu um erro interno, tente novamente mais tarde.');
                
            }
        }
    }


    return (<div class="main-content" style={{marginLeft: '0'}}>
        <Menu />
    <div id="page-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-md-offset-4" style={{marginTop: '100px'}}>
                    <img src={'../public/assets/logoupbusca.png'} alt="Up Busca" class="center-block img-responsive" id="logo" style={{marginTop: '-10%'}}/>
                </div>
            </div>
        </div>
    <div>

    {trava == false ? <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <ul class="nav nav-tabs" role="tablist" style={{marginTop: '0px'}}>
                <li role="presentation" class="active">
                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab" class="tab-result">Dados cadastrais</a>
                </li>
            </ul>

            <div class="tab-content">
                <div role="tabpanel" class="tab-pane active" id="home">
                    <div class="table-responsive" style={{marginTop: '25px'}}>
                    <div class="row">
			
                        <div>
                            <div class="form-group col-md-12">
                                <span>Usuario:</span>
                                <input type="text" class="form-control" id="usuario" name="usuario" value={dados.usuario} disabled/>
                            </div>

                            <div class="form-group col-md-12">
                                <span>Senha:</span>
                                <input type="password" class="form-control" id="senha" name="senha" placeholder="Digite sua senha" value={senha} onChange={(e) => setSenha(e.target.value)}/>
                            </div>

                            <div class="form-group col-md-12">
                                <span>Digite sua nova senha:</span>
                                <input type="password" class="form-control" id="nova_senha" name="nova_senha" placeholder="Digite sua nova senha" value={novaSenha} onChange={ (e) => setNovaSenha(e.target.value) }/>
                            </div>

                            <div class="form-group col-md-12">
                                <span>Confirme sua nova senha:</span>
                                <input type="password" class="form-control" id="c_nova_senha" name="c_nova_senha" placeholder="Digite sua nova senha" value={confirmar} onChange={(e) => setConfirmar(e.target.value)}/>
                            </div>
                            
                            <div className='form-groud col-md-12'>
                            {msg.length > 0 ? <center>{msg}</center> : ''}

                                                            <br/>
                                <center><button id="btAtualizarSenha" type="button" onClick={Editar} class="btn btn-primary">Editar senha</button></center>
                            </div>

                        </div>
                        <br/>
                    </div>
                    <br/>
                    </div>
                </div>
            </div>
        </div>
    </div> : (``)}

  
</div>

</div></div>);
}

export default Cadastro;
